module.exports = __webpack_public_path__ + "img/transflo-express.6e7bb7c4.svg";